import PersonTags from '@/features/people-tags/components/PersonTags.vue';
import PeopleTagsFilter from '@/features/people-tags/components/PeopleTagsFilter.vue';
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import PrimeVue from 'primevue/config';
import { definePreset } from '@primeuix/themes';
import axios from 'axios';
import VueAxios from 'vue-axios';
import { recoverFromChunkLoadError } from '@/utils/chunkLoadRecovery';
import { restoreApplicationScroll, startApplicationVersionCheck } from '@/utils/applicationUpdate';
import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';
import Tooltip from 'primevue/tooltip';
import PanelMenu from 'primevue/panelmenu';
import Menubar from 'primevue/menubar';
import Button from 'primevue/button';
import Menu from 'primevue/menu';
import InputNumber from 'primevue/inputnumber';
import InputText from 'primevue/inputtext';
import Dialog from 'primevue/dialog';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Toolbar from 'primevue/toolbar';
import Tag from 'primevue/tag';
import Skeleton from 'primevue/skeleton';
import ConfirmDialog from 'primevue/confirmdialog';
import MultiSelect from 'primevue/multiselect';
import FloatLabel from 'primevue/floatlabel';

// PrimeVue theme first, then Tailwind for override priority
import Aura from '@primeuix/themes/aura';
import '@/assets/primeicons/primeicons.css';
import 'cropperjs/dist/cropper.css';
import 'vue-picture-cropper/style.css';
import './assets/css/primevue-custom.css';
import './assets/layout.css';
// Tailwind импортируется в самом конце для максимального приоритета
import './assets/css/tailwind.css';
// CRC HR workspace design tokens (scoped to the /hr-workspace preview shell)
import './assets/css/crc-theme.css';
import './assets/css/crc-datatable-frozen.css';
import './assets/css/crc-form-dialog.css';
import './assets/css/crc-buttons.css';
import './assets/css/crc-mobile.css';
import { FilterService } from '@primevue/core/api';
import { installChartJsTooltipGuard } from '@/utils/chartJsTooltipGuard';
import { installSmartContainsFilter } from '@/utils/primeFilterSearch';

installChartJsTooltipGuard();
installSmartContainsFilter(FilterService);

const app = createApp(App)
app.component('PersonTags', PersonTags);
app.component('PeopleTagsFilter', PeopleTagsFilter);

// Global error handling
app.config.errorHandler = (error, _instance, info) => {
  if (recoverFromChunkLoadError(error)) {
    return;
  }
  console.error('[Vue]', info || 'error', error);
};

// Handle unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  if (recoverFromChunkLoadError(event.reason)) {
    event.preventDefault();
  }
});

// A truncated cached chunk fails to parse before webpack rejects the import.
window.addEventListener('error', (event) => {
  const filename = String(event?.filename || '');
  const message = String(event?.message || '');
  if (!filename.includes('/js/') || !message.toLowerCase().includes('unexpected end of input')) {
    return;
  }
  if (recoverFromChunkLoadError({
    name: 'ChunkLoadError',
    message,
    filename,
    request: filename
  })) {
    event.preventDefault();
  }
}, true);



const MyPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: '#f0f9f1',
            100: '#dcf2de',
            200: '#bce5c0',
            300: '#8dd396',
            400: '#57bb64',
            500: '#277e32',
            600: '#1f5f28',
            700: '#174620',
            800: '#0f2d18',
            900: '#071410',
            950: '#030a05'
        }
    }
});


app.use(PrimeVue, {
    theme: {
        preset: MyPreset,
        options: {
            darkModeSelector: '.dark-mode'
        }
    }
});

app.use(store);
app.use(router);
app.use(VueAxios, axios);

app.use(ToastService);
app.use(ConfirmationService);
app.component('Toast', Toast);
app.component('PanelMenu', PanelMenu);
app.component('Menubar', Menubar);
app.component('Button', Button);
app.component('Menu', Menu);
app.component('InputNumber', InputNumber);
app.component('InputText', InputText);
app.component('Dialog', Dialog);
app.component('DataTable', DataTable);
app.component('Column', Column);
app.component('Toolbar', Toolbar);
app.component('Tag', Tag);
app.component('Skeleton', Skeleton);
app.component('ConfirmDialog', ConfirmDialog);
app.component('MultiSelect', MultiSelect);
app.component('FloatLabel', FloatLabel);
app.directive('tooltip', Tooltip);

store.dispatch('initializeTheme');
store.dispatch('users/initializeAuth')
  .catch(() => {})
  .finally(() => {
    store.dispatch('navigation/initHistory');
    app.mount('#app');
    startApplicationVersionCheck({ router });
    restoreApplicationScroll();
  });

